export default "__VITE_ASSET__40ea1fad__"